import React from 'react';
import classNames from 'classnames';
import { Props } from './Box.types';

import styles from './Box.module.scss';

const Box: React.FC<Props> = ({ title, children, padding, className }) => {
  const paddingClasses: string = padding
    ? `${styles['box-no-padding']} ` + padding.map((direction) => styles[`box-padding-${direction}`]).join(' ')
    : '';

  return (
    <div className={classNames(styles.box, paddingClasses, className)}>
      {title && <h2 className={styles.box__title}>{title}</h2>}
      <div className={styles.box__content}>{children}</div>
    </div>
  );
};

export default Box;
